import * as React from 'react';
import { LinearProgress } from '@mui/material';
import { useAppContext } from '../../contexts/AppContext';
import { NavigationMenuItem } from './NavigationMenuItem';

interface NavigationMenuProps {
  sliceAmount?: number;
  size?: 'small' | 'medium' | 'large' | undefined;
}

export const NavigationMenu = (props: NavigationMenuProps) => {
  const { sliceAmount } = props;
  const appContext = useAppContext();
  const { categories, isLoading } = appContext.useCategories();
  const [sliceIndex, setSliceIndex] = React.useState(sliceAmount);

  React.useEffect(() => {
    setSliceIndex(sliceAmount);

    return () => {
      setSliceIndex(10);
    };
  }, [sliceAmount]);

  return (
    <>
      {isLoading && <LinearProgress color="secondary" />}
      {categories &&
        categories
          .slice(0, sliceIndex)
          .map((item: any, index) => (
            <NavigationMenuItem
              key={index}
              title={item.name}
              href={item?.code ? `/category/${item.code}` : `${item.href}`}
              dense={true}
            />
          ))}
    </>
  );
};
